// Utility: render heading with italicized accent word
import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

export const Italic = ({ children, className = "" }) => (
  <span className={`italic font-serif-display ${className}`}>{children}</span>
);

// Section wrapper
export const Section = ({ id, bg = "cream", className = "", children, ...rest }) => {
  const bgClass =
    bg === "dark"
      ? "bg-[#14401F] text-white"
      : bg === "darker"
      ? "bg-[#0F2818] text-white"
      : bg === "sage"
      ? "bg-[#DCE8C9] text-[#0F2818]"
      : "bg-[#F7F8EF] text-[#0F2818]";
  return (
    <section id={id} className={`${bgClass} ${className} relative overflow-hidden`} {...rest}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">{children}</div>
    </section>
  );
};

// Pill badge
export const Pill = ({ children, variant = "outline", className = "" }) => {
  const base = "inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium uppercase tracking-wider";
  const variantCls =
    variant === "lime"
      ? "bg-[#B8D958] text-[#0F2818]"
      : variant === "dark"
      ? "bg-[#14401F] text-[#B8D958]"
      : "border border-[#14401F]/30 text-[#14401F]";
  return <span className={`${base} ${variantCls} ${className}`}>{children}</span>;
};

// Eyebrow heading — theme-aware for readability on both light and dark
export const Eyebrow = ({ children, color }) => {
  const { theme } = useTheme();
  // In dark mode, always render as vivid lime unless caller passes an explicit accent
  const resolvedColor = color
    ? color
    : theme === "dark"
    ? "#B8D958"
    : "#14401F";
  return (
    <div className="flex items-center gap-3 mb-5">
      <span className="h-px w-10" style={{ background: resolvedColor }} />
      <span
        className="text-xs uppercase tracking-[0.25em] font-semibold"
        style={{ color: resolvedColor }}
      >
        {children}
      </span>
    </div>
  );
};
